<ng-container *ngIf="form">
  <osn-cxb-dialog [title]="redeemDialogTitle" class="redeem-page-dialog-container">
    <form [formGroup]="form">
      <mat-form-field>
        <input
          matInput
          trim="blur"
          type="text"
          placeholder="Page internal name"
          autocomplete="off"
          [formControl]="formControls.internalName"
          data-testid="redeem-page-dialog-internal-name-input"
        />
      </mat-form-field>
      <mat-form-field class="mt-3">
        <input
          matInput
          trim="blur"
          type="text"
          placeholder="Page tab title - English"
          autocomplete="off"
          [formControl]="formControls.tabTitleEnglish"
          data-testid="redeem-page-dialog-english-name-input"
        />
      </mat-form-field>
      <mat-form-field class="mt-3">
        <input
          matInput
          trim="blur"
          type="text"
          placeholder="Page tab title - Arabic"
          autocomplete="off"
          [formControl]="formControls.tabTitleArabic"
          data-testid="redeem-page-dialog-arabic-name-input"
        />
      </mat-form-field>

      <div class="mt-3 d-flex align-items-center">
        <span>{{ redeemPageTargetBaseUrl }}/en-ae/redeem/</span>
        <mat-form-field class="ml-1">
          <input
            [readonly]="!(data.variant === PageDialogVariant.NEW) ? true : null"
            matInput
            trim="blur"
            type="text"
            placeholder="Page URL"
            autocomplete="off"
            [formControl]="formControls.pageUrl"
            data-testid="redeem-page-dialog-page-url-input"
          />
        </mat-form-field>
      </div>

      <div class="mt-3">
        <p>Target URL list:</p>
        <div class="d-flex pt-2">
          <div class="url-list-container">
            <p *ngFor="let url of redeemTargetUrls">{{ url }}</p>
          </div>
          <button class="copy-btn secondary ml-1" (click)="onCopyClick()" data-testid="redeem-page-dialog-copy-to-clipboard-btn">
            Copy to clipboard
          </button>
        </div>
      </div>

      <osn-cxb-country-targeting-control
        class="mt-3"
        [countryOptions]="countryOptions$ | async"
        [countryIdsControl]="formControls.countryIds"
        [data-testid]="'redeem-page-dialog-country-select'"
      ></osn-cxb-country-targeting-control>

      <osn-cxb-user-targeting-control
        class="mt-3"
        [userSegmentOptions]="userSegmentOptions$ | async"
        [userSegmentIdsControl]="formControls.userSegmentIds"
        [emitValueOnRegisterOnChange]="true"
        [data-testid]="'redeem-page-dialog-user-segment-select'"
      ></osn-cxb-user-targeting-control>

      <div class="meta-groups mt-3" formArrayName="metaTags">
        <div class="meta-group" *ngFor="let _ of metaTags.controls; index as i">
          <ng-container [formGroupName]="i">
            <mat-form-field class="meta-key">
              <input trim="blur" matInput type="text" formControlName="key" placeholder="Meta tag (key)" autocomplete="off" />
            </mat-form-field>
            <mat-form-field>
              <input trim="blur" matInput type="text" formControlName="value" placeholder="Meta tag (value)" autocomplete="off" />
            </mat-form-field>
          </ng-container>
        </div>
      </div>
      <div *ngIf="data.variant !== PageDialogVariant.READ_ONLY" class="mt-2">
        <span class="add-meta" (click)="addNewMetaTag()">
          <svg-icon key="plus" class="inline-icon"></svg-icon>
          Add meta tag</span
        >
      </div>
      <div class="action">
        <button
          class="action-btn mt-4"
          type="button"
          [disabled]="form.invalid || !form.dirty"
          (click)="onSaveClick()"
          data-testid="redeem-page-dialog-create-update-btn"
        >
          {{ dialogAction }}
        </button>
      </div>
    </form>
  </osn-cxb-dialog>
</ng-container>
